import { selectLayout } from 'layout/store/selectors';
import State from 'store/State';
import { useShallowEqualSelector } from 'utils/hooks/useShallowEqualSelector';

const selectLayoutRendererState = (state: State) => {
    return state.layoutRenderer;
};

export const selectLayoutRenderer = (state: State) => {
    const layoutRendererState = selectLayoutRendererState(state);

    const result = selectLayout(state) || { id: null, shape: undefined };
    const { id: layoutId, shape: layoutShape } = result;

    return {
        locked: layoutRendererState.locked,
        pendingWidgetsToAdd: layoutRendererState.pendingWidgetsToAdd,
        layoutId,
        layoutShape,
    };
};

export const useSelectLocked = () =>
    useShallowEqualSelector((state: State) => {
        const layoutRendererState = selectLayoutRendererState(state);
        return layoutRendererState.locked;
    });
